module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('md-card', {
    staticClass: "ql-cue",
    style: (_vm.styles),
    attrs: {
      "id": _vm.cue.id
    }
  }, [_c('project-cues-cue-header', {
    ref: "ql-cue-header",
    attrs: {
      "expanded": _vm.expanded,
      "isEditing": _vm.isEditing,
      "isEditingDescription": _vm.isEditingDescription,
      "cue": _vm.cue,
      "layer": _vm.layer,
      "layers": _vm.editableLayers,
      "locked": _vm.locked,
      "editable": _vm.editable,
      "color": _vm.color,
      "totalPages": _vm.totalPages,
      "isFloatingCue": _vm.isFloatingCue
    },
    on: {
      "toggle": _vm.toggle,
      "cueUpdated": _vm.updatedCue,
      "updateStatus": _vm.updateStatus,
      "tetherCue": _vm.tetherCue,
      "untetherCue": _vm.untetherCue
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8708f1fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/cues/cue.vue
// module id = 1274
// module chunks = 21